import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoContainerV3Component, DecodeHtmlString } from './video-container-v3.component';
import { AngularSharedUiNmoModule } from '../angular-shared-ui-nmo.module';
import { AngularSharedUtilNmoModule } from '@candyland/angular/shared/util-nmo';

@NgModule({
  declarations: [VideoContainerV3Component, DecodeHtmlString],
  imports: [CommonModule, AngularSharedUiNmoModule, AngularSharedUtilNmoModule],
  exports: [VideoContainerV3Component],
})
export class VideoContainerV3Module {}
